/*
 * @Description: 已支付。
                 downDeail组件中根据childActiveIndex进行入参处理，childActiveIndex变化需要修改这个组件入参。
 * @Date: 2020-12-12 17:43:20
 */

import { Loading } from 'element-ui';
import fields, { priceTypeMap } from './fields';
import { createTotalPayment, reMark } from './fields';
import search from './search';
import downDeail from '../child/downDeail';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { csoCustomerOrder, downloadBankPayUrl } from '@/api/ajax';
import { userEnterpriseType as userEnterpriseTypeSearch } from '@/page/settlementCenter/common/tableConfig/search.js';
import { userEnterpriseType as userEnterpriseTypeField } from '@/page/settlementCenter/common/tableConfig/fields.js';
import {
  bankRowLabelFiled,
  bankSearchFiled,
  payTypeRowLabelFiled,
  payTypeSearchFiled
} from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';

let example = new TableRenderClass({ fields, search });
const downPayDetail = {
  name: '批量下载支付详情',
  type: 'primary',
  disabled: true,
  async fn(app, table) {
    const data = table.$parent.elTableRef.selection;
    // eslint-disable-next-line no-useless-escape
    const downSelctArr = data.map(item => {
      return {
        id: item.id,
        csoCustomOrderIds: item.csoCustomOrderIds,
        downLoadSign: item.downLoadSign
      };
    });
    if (data.length == 0) {
      table.$message({
        message: '请先勾选',
        type: 'warning'
      });
      return;
    } else if (data.some(item => item.priceType != 1)) {
      table.$message({
        message: '费用类型只能为项目费用',
        type: 'warning'
      });
      return;
    } else if (!table.searchQuery.payPassagewayCode) {
      table.$message({
        message: '请先选择支付通道',
        type: 'warning'
      });
      return;
    }
    table.$xrkDialog({
      title: '批量下载支付详情',
      showCancel: false,
      showConfirm: false,
      width: '500px',
      $slots: {
        default: table.$createElement(downDeail, {
          props: {
            childActiveIndex: table.childActiveIndex,
            selectArr: downSelctArr,
            payPassagewayCode: table.searchQuery.payPassagewayCode
          },
          on: {
            confirm: () => {
              table.saveSuccess();
              table.$xrkDialog.remove();
            }
          }
        })
      }
    });
  }
};

const downloadReceipt = {
  name: '批量下载回单',
  type: 'primary',
  key: 'myorder-paid-downloadReceipt',
  async fn(app, table) {
    const data = table.$parent.elTableRef.selection;
    const maxDay = 30;
    let chooseStartDate, chooseEndDate;
    try {
      [chooseStartDate, chooseEndDate] = table.searchQuery.finishPay || [];
    } catch (error) {
      console.warn(error);
    }
    // 没有选择完成时间
    if (!chooseStartDate || !chooseEndDate) {
      table.$message({
        message: '请选择完成时间并完成搜索',
        type: 'warning'
      });
      return;
    }
    // 完成时间范围超过 最大天数maxDay 设置
    if (
      (new Date(chooseEndDate) - new Date(chooseStartDate)) / 86400000 >=
      maxDay
    ) {
      table.$xrkDialog({
        title: '提示',
        showCancel: false,
        width: '500px',
        $slots: {
          default: table.$createElement(
            'div',
            { style: { fontSize: '16px' } },
            [
              table.$createElement('span', {}, '为保证导出性能，最大只能'),
              table.$createElement(
                'span',
                { style: { color: 'red' } },
                `下载${maxDay}天的回单，`
              ),
              table.$createElement('span', {}, '请调整起止时间后重新下载')
            ]
          )
        },
        success: () => {
          table.$xrkDialog.remove();
        }
      });
      return;
    }

    // 是否勾选数据
    if (!Array.isArray(data) || data.length == 0) {
      table.$message({
        message: '请选择数据',
        type: 'warning'
      });
      return;
    }

    const { downloadBankPayUrlList, maxTime, minTime } = data.reduce(
      (pre, cur) => {
        pre.downloadBankPayUrlList.push({
          priceType: priceTypeMap[cur.priceType],
          finishPayDt: cur.finishPayDt,
          ids: cur.csoCustomOrderIds
        });
        const finishPayDt = new Date(cur.finishPayDt).getTime();
        pre.maxTime = Math.max(pre.maxTime, finishPayDt);
        pre.minTime =
          pre.minTime == 0 ? finishPayDt : Math.min(pre.minTime, finishPayDt);
        return pre;
      },
      {
        maxTime: 0,
        minTime: 0,
        downloadBankPayUrlList: []
      }
    );
    // 选中数据，完成时间超出搜索条件的完成时间范围
    if (
      minTime < new Date(`${chooseStartDate} 00:00:00`).getTime() ||
      maxTime > new Date(`${chooseEndDate} 23:59:59`).getTime()
    ) {
      table.$message({
        message: '请选择完成时间并完成搜索',
        type: 'warning'
      });
      return;
    }

    const loading = Loading.service({ fullscreen: true, text: '下载中...' });
    try {
      await downloadBankPayUrl({
        finishPayStartTime: chooseStartDate,
        finishPayEndTime: chooseEndDate,
        downloadBankPayUrlList: downloadBankPayUrlList
      });
      table.$confirm(
        '文件已经在下载中心内进行生成,如需下载请前往下载中心',
        '',
        {
          showCancelButton: false,
          showConfirmButton: false
        }
      );
    } catch (error) {
      console.warn(error);
    }
    loading.close();
  }
};
const batchPart = example.createPart({
  name: '按生成批次展示',
  search: [
    'orderNo',
    'batchOrderNo',
    'projectName',
    userEnterpriseTypeSearch,
    'dingdanshengchengshijian',
    'wanchengshijian',
    'paymentDeadline',
    'feeType',
    'industrial',
    bankSearchFiled,
    payTypeSearchFiled
  ],
  list: csoCustomerOrder.payOrderList,
  defaultQuery: { tag: 1 },
  requestNow: true,
  fields: [
    {
      type: 'selection',
      width: '40px',
      reserve: true
    },
    'index',
    'batchOrderNo',
    {
      label: '生成时间',
      prop: 'createDt',
      width: '180px'
    },
    {
      label: '完成时间',
      prop: 'finishPayDt',
      width: '180px'
    },
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    userEnterpriseTypeField,
    createTotalPayment(3, '打款总金额', 'orderPrice'),
    'feeType',
    reMark(),
    'finishOperation'
  ],
  moreBtnArr: [downPayDetail, downloadReceipt]
});

const projectPart = example.createPart({
  name: '按项目展示',
  search: [
    'orderNo',
    'batchOrderNo',
    'projectName',
    userEnterpriseTypeSearch,
    'dingdanshengchengshijian',
    'wanchengshijian',
    'paymentDeadline',
    'feeType',
    'remark',
    'industrialReal',
    bankSearchFiled,
    payTypeSearchFiled,
    'isComplete'
  ],
  list: csoCustomerOrder.payOrderList,
  defaultQuery: { tag: 2 },
  requestNow: true,
  fields: [
    {
      type: 'selection',
      width: '40px',
      reserve: true
    },
    'index',
    'orderNo',
    'projectName',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'batchOrderNo',
    {
      label: '订单生成时间',
      prop: 'createDt',
      width: '180px'
    },
    {
      label: '完成时间',
      prop: 'finishPayDt',
      width: '180px'
    },
    userEnterpriseTypeField,
    'industryName',
    createTotalPayment(3, '打款总金额', 'orderPrice'),
    'feeType',
    {
      label: '完结状态',
      prop: 'isComplete',
      render: (h, ctx, row) => {
        return (
          <span>{['-', '手动完结', '正常完结'][+row.isComplete || 0]}</span>
        );
      }
    },
    'remark',
    'finishOperation'
  ],
  moreBtnArr: [downPayDetail, downloadReceipt]
});
export default {
  name: '已支付订单',
  key: 'myorder-paid',
  childMenu: [projectPart, batchPart]
};
